var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopNavLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 40,
    viewBox: "0 0 190 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.751 16.1055L20.167 20.4855L27.751 24.8624L35.335 20.4855L27.751 16.1055Z",
    fill: "#8276FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.752 24.8652V33.6222L35.336 29.2452V20.4883L27.752 24.8652Z",
    fill: "#5948FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.584 33.6202V24.8633L20.168 29.2433L12.584 33.6202Z",
    fill: "#3326B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.7266V20.4866V29.2435L12.584 33.6205V24.8635V16.1066L5 11.7266Z",
    fill: "#5948FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.168 29.2433L12.584 33.6202L20.168 38.0002L27.752 33.6202V24.8633L20.168 29.2433Z",
    fill: "url(#paint0_linear_1759_9462)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.168 3L12.584 7.38002L5 11.7569L12.584 16.137L20.168 11.7569L27.752 7.38002L20.168 3Z",
    fill: "#8276FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9399 29.2463C47.7874 29.2463 44.085 25.4513 44.085 20.4932C44.085 15.5351 47.7442 11.7617 52.8288 11.7617C56.8212 11.7617 60.2089 14.1405 61.3042 17.9817H57.6234C56.9107 16.2077 55.1243 14.9057 52.8936 14.9057C49.7712 14.9057 47.5868 17.2629 47.5868 20.521C47.5868 23.7791 49.7959 26.1548 53.0077 26.1548C55.5716 26.1548 57.5123 24.6492 58.2281 22.4709H53.523V19.9348H61.5325C61.5541 20.0242 61.5757 20.5426 61.5757 20.6752C61.5757 25.5254 57.7622 29.2494 52.946 29.2494H52.9429L52.9399 29.2463Z",
    fill: "#232323"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2007 29.2455H64.1953V11.7578H75.2038V14.7413H67.7434V18.6813H74.5435V21.3624H67.7434V26.262H75.2007V29.2455Z",
    fill: "#232323"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8315 29.2455H77.8262V11.7578H88.8346V14.7413H81.3743V18.6813H88.1744V21.3624H81.3743V26.262H88.8315V29.2455Z",
    fill: "#232323"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7394 21.3633L94.9962 21.3571V29.2494H91.4512V11.7617H94.9962V18.6852H96.4957L100.615 11.7617H104.573L99.7754 19.7342L105.221 29.2463H101.17L96.7363 21.3633H96.7394Z",
    fill: "#232323"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M106.538 29.2469V26.214H113.24C115.368 26.214 116.235 24.9768 116.235 23.6717C116.235 22.4345 115.572 21.2467 113.261 21.2467H111.614C108.618 21.2467 106.535 19.3337 106.535 16.5354C106.535 13.737 108.618 11.7562 111.706 11.7562L119.231 11.75V14.7829L112.323 14.7891C110.95 14.7891 110.287 15.582 110.287 16.6063C110.287 17.5381 110.95 18.3341 112.323 18.3341H113.878C117.929 18.3341 119.898 20.7592 119.898 23.7211C119.898 26.683 117.908 29.2469 113.81 29.2469H106.538Z",
    fill: "#232323"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M138.771 29.2455H127.769V11.7578H131.314V26.2589H138.771V29.2424V29.2455Z",
    fill: "#232323"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M148.172 29.2455C143.105 29.2455 139.428 25.4505 139.428 20.4677C139.428 15.4849 143.109 11.7578 148.172 11.7578C153.235 11.7578 156.915 15.5096 156.915 20.4677C156.915 25.4258 153.262 29.2455 148.172 29.2455ZM148.172 25.9658C151.279 25.9658 153.438 23.6302 153.438 20.5078C153.438 17.3855 151.282 15.0067 148.172 15.0067C145.062 15.0067 142.886 17.3423 142.886 20.5078C142.886 23.6734 145.068 25.9658 148.172 25.9658Z",
    fill: "#232323"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M163.086 21.3655V29.2455H159.541V11.7578H170.543V14.7413H163.086V18.6813H169.889V21.3624H163.086V21.3655Z",
    fill: "#232323"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M177.421 29.2455V14.7413H173.166V11.7578H185.14V14.7413H180.966V29.2424H177.418L177.421 29.2455Z",
    fill: "#232323"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1759_9462",
    x1: 12.584,
    y1: 31.4318,
    x2: 27.752,
    y2: 31.4318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5948FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3326B1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopNavLogo);
export default __webpack_public_path__ + "static/media/topNavLogo.9ec67ee188b1f18709fd889dadd1b69b.svg";
export { ForwardRef as ReactComponent };